import { Injectable } from '@angular/core';
//import { InvisibleReCaptchaComponent } from 'ngx-captcha';


@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  public captchaElem: any
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;
  public badge: 'bottomright' | 'bottomleft' | 'inline' = 'inline';
  public type: 'image' | 'audio';

  constructor() {
  }

  /**MEtodo encargado de ejecutar el Captcha */
  public executeCaptcha(/*captchaElem: InvisibleReCaptchaComponent*/) {
    //this.captchaElem = captchaElem;
    this.captchaElem.execute()
  }

  /**Metodo utilizado cuando se completa exitosamente un captcha */
  public handleSuccessCaptcha(captchaResponse: string) {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    //this.cdr.detectChanges();
  }

  /**Metodo utilizado cuando se ha cargado el captcha */
  public handleLoadCaptcha(): void {
    this.captchaIsLoaded = true;
    //this.cdr.detectChanges();
  }

  /**Método utilizado cuando esta listo para utilizar el captcha */
  public handleReadyCaptcha(): void {
    this.captchaIsReady = true;
    //this.cdr.detectChanges();
  }

  /**Método utilizado para recargar el captha */
  public reloadCaptcha(): void {
    this.captchaElem.reloadCaptcha();
  }

}

